import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DeckQuestion } from '../../strategy-deck.models';

@Component({
  selector: 'app-deck-research-question',
  templateUrl: './deck-research-question.component.html',
  styleUrl: './deck-research-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeckResearchQuestionComponent {

  @Input({ required: true }) question!: DeckQuestion;
  @Input() checked = false;
  @Input() disabled = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  protected onToggle(event: Event): void {
    this.checkedChange.emit((event.target as HTMLInputElement).checked);
  }
}
